import ABMapInteractiveViewer from "./ab-map-interactive-viewer";

const viewers = document.body.querySelectorAll('.ab-map-interactive-viewer');
viewers.forEach(viewer => {
    const map = new ABMapInteractiveViewer(viewer);
    map.init();
});